<div class="profile-container">
  <!-- Profile Header with Avatar -->
  <div class="profile-header-card">
    <div class="profile-header-content">
    <div class="avatar-section">
        <div class="avatar-wrapper">
      <div class="avatar">
        <img *ngIf="avatarPreviewUrl" [src]="avatarPreviewUrl" alt="Profile avatar" class="avatar-img" (error)="onImageError($event)" />
            <div *ngIf="!avatarPreviewUrl" class="avatar-placeholder">
              <span class="avatar-initials">{{ (profileForm.get('firstName')?.value || 'U').slice(0,1) }}</span>
            </div>
            <div class="avatar-upload-overlay">
              <label class="upload-btn">
                <input type="file" accept="image/*" (change)="onAvatarSelected($event)" [disabled]="avatarUploading" />
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ avatarUploading ? 'Uploading...' : 'Change Photo' }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="profile-title-section">
          <h1 class="profile-title">My Profile</h1>
          <p class="profile-subtitle">Manage your personal information and share referral links</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Status Messages -->
  <div *ngIf="loading" class="status-message loading">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="31.416" stroke-dashoffset="31.416">
        <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite"/>
        <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite"/>
      </circle>
    </svg>
    <span>Loading profile...</span>
  </div>
  <div *ngIf="error" class="status-message error">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
      <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2"/>
      <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2"/>
    </svg>
    <span>{{ error }}</span>
  </div>
  <div *ngIf="success" class="status-message success">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 11.08V12A10 10 0 1 1 5.93 5.93" stroke="currentColor" stroke-width="2"/>
      <polyline points="22,4 12,14.01 9,11.01" stroke="currentColor" stroke-width="2"/>
    </svg>
    <span>{{ success }}</span>
  </div>

  <!-- Referral Links Section -->
  <div class="referral-links-section" *ngIf="!loading && profileData">
    <h2 class="section-title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 13A5 5 0 0 0 20 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M14 17A5 5 0 0 0 4 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M10 13A3 3 0 0 1 13 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <path d="M14 17A3 3 0 0 1 17 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <line x1="13" y1="10" x2="17" y2="14" stroke="currentColor" stroke-width="2"/>
      </svg>
      Share Referral Links
    </h2>
    <p class="section-description">Share these links with family members to invite them to join your family tree</p>
    
    <div class="referral-cards-grid">
      <!-- Parent Referral Link (for adding children) -->
      <div class="referral-card parent-card">
        <div class="referral-card-header">
          <div class="referral-icon parent-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21V19A4 4 0 0 0 13 15H5A4 4 0 0 0 1 19V21" stroke="currentColor" stroke-width="2"/>
              <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
              <path d="M23 21V19A4 4 0 0 0 19.5 15.5" stroke="currentColor" stroke-width="2"/>
              <path d="M16 3.13A4 4 0 0 1 16 10.87" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3 class="referral-card-title">For Children</h3>
        </div>
        <p class="referral-card-description">Share this link with your children to add them to your family tree</p>
        <div class="referral-link-input-group">
          <input 
            type="text" 
            [value]="parentReferralLink" 
            readonly 
            class="referral-link-input"
            [class.disabled]="!parentReferralLink"
            placeholder="Loading..." />
          <div class="referral-link-actions">
            <button 
              type="button" 
              class="copy-btn"
              (click)="copyToClipboard(parentReferralLink, 'Parent')"
              [disabled]="!parentReferralLink"
              title="Copy link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button 
              type="button" 
              class="share-btn"
              (click)="shareLink('parent')"
              [disabled]="!parentReferralLink"
              title="Share link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" stroke="currentColor" stroke-width="2"/>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Spouse Referral Link -->
      <div class="referral-card spouse-card">
        <div class="referral-card-header">
          <div class="referral-icon spouse-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="4" stroke="currentColor" stroke-width="2"/>
              <circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
              <path d="M11 11L13 13" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3 class="referral-card-title">For Spouse</h3>
        </div>
        <p class="referral-card-description">Share this link with your spouse to connect them to your family tree</p>
        <div class="referral-link-input-group">
          <input 
            type="text" 
            [value]="spouseReferralLink" 
            readonly 
            class="referral-link-input"
            [class.disabled]="!spouseReferralLink"
            placeholder="Loading..." />
          <div class="referral-link-actions">
            <button 
              type="button" 
              class="copy-btn"
              (click)="copyToClipboard(spouseReferralLink, 'Spouse')"
              [disabled]="!spouseReferralLink"
              title="Copy link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button 
              type="button" 
              class="share-btn"
              (click)="shareLink('spouse')"
              [disabled]="!spouseReferralLink"
              title="Share link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" stroke="currentColor" stroke-width="2"/>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Sibling Referral Link -->
      <div class="referral-card sibling-card">
        <div class="referral-card-header">
          <div class="referral-icon sibling-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
              <path d="M5 21V19A4 4 0 0 1 9 15H15A4 4 0 0 1 19 19V21" stroke="currentColor" stroke-width="2"/>
              <circle cx="8" cy="7" r="3" stroke="currentColor" stroke-width="2"/>
              <circle cx="16" cy="7" r="3" stroke="currentColor" stroke-width="2"/>
            </svg>
          </div>
          <h3 class="referral-card-title">For Siblings</h3>
        </div>
        <p class="referral-card-description" *ngIf="siblingReferralLink">
          Share this link with your siblings to add them to your family tree (uses parent's referral code)
        </p>
        <p class="referral-card-description error" *ngIf="!siblingReferralLink">
          Sibling link is only available if you have a parent registered in the system
        </p>
        <div class="referral-link-input-group">
          <input 
            type="text" 
            [value]="siblingReferralLink" 
            readonly 
            class="referral-link-input"
            [class.disabled]="!siblingReferralLink"
            placeholder="Not available - no parent registered" />
          <div class="referral-link-actions">
            <button 
              type="button" 
              class="copy-btn"
              (click)="copyToClipboard(siblingReferralLink, 'Sibling')"
              [disabled]="!siblingReferralLink"
              title="Copy link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                <path d="M5 15H4A2 2 0 0 1 2 13V4A2 2 0 0 1 4 2H13A2 2 0 0 1 15 4V5" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
            <button 
              type="button" 
              class="share-btn"
              (click)="shareLink('sibling')"
              [disabled]="!siblingReferralLink"
              title="Share link">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                <circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="2"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" stroke="currentColor" stroke-width="2"/>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Profile Information Form -->
  <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" *ngIf="!loading" class="profile-form">
    <div class="form-section">
      <h2 class="section-title">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 21V19A4 4 0 0 0 16 15H8A4 4 0 0 0 4 19V21" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
        </svg>
        Personal Information
      </h2>
      
      <div class="form-grid">
        <div class="form-group">
          <label class="form-label">First Name <span class="required">*</span></label>
          <input type="text" formControlName="firstName" class="form-input" [class.error]="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched" />
          <div class="error-message" *ngIf="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched">
            First name is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Middle Name</label>
          <input type="text" formControlName="middleName" class="form-input" />
        </div>

        <div class="form-group">
          <label class="form-label">Last Name <span class="required">*</span></label>
          <input type="text" formControlName="lastName" class="form-input" [class.error]="profileForm.get('lastName')?.invalid && profileForm.get('lastName')?.touched" />
          <div class="error-message" *ngIf="profileForm.get('lastName')?.invalid && profileForm.get('lastName')?.touched">
            Last name is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Email</label>
          <input type="email" formControlName="email" class="form-input" [class.error]="profileForm.get('email')?.invalid && profileForm.get('email')?.touched" placeholder="Email (optional if mobile provided)" />
          <div class="error-message" *ngIf="profileForm.get('email')?.invalid && profileForm.get('email')?.touched">
            Please enter a valid email
          </div>
          <small class="help-text">At least one of email or mobile number is required</small>
        </div>

        <div class="form-group">
          <label class="form-label">Mobile Number</label>
          <input type="tel" formControlName="mobileNumber" class="form-input" [class.error]="profileForm.get('mobileNumber')?.invalid && profileForm.get('mobileNumber')?.touched" placeholder="Mobile (optional if email provided)" />
          <div class="error-message" *ngIf="profileForm.get('mobileNumber')?.invalid && profileForm.get('mobileNumber')?.touched">
            Mobile number is required if email is not provided
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Date of Birth <span class="required">*</span></label>
          <input type="date" formControlName="dateOfBirth" class="form-input" [class.error]="profileForm.get('dateOfBirth')?.invalid && profileForm.get('dateOfBirth')?.touched" />
          <div class="error-message" *ngIf="profileForm.get('dateOfBirth')?.invalid && profileForm.get('dateOfBirth')?.touched">
            Date of birth is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Gender <span class="required">*</span></label>
          <select formControlName="gender" class="form-input" [class.error]="profileForm.get('gender')?.invalid && profileForm.get('gender')?.touched">
            <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
          <div class="error-message" *ngIf="profileForm.get('gender')?.invalid && profileForm.get('gender')?.touched">
            Gender is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Qualification</label>
          <input type="text" formControlName="qualification" class="form-input" placeholder="Optional" />
        </div>

        <div class="form-group">
          <label class="form-label">Profession</label>
          <input type="text" formControlName="profession" class="form-input" placeholder="Optional" />
        </div>

        <div class="form-group">
          <label class="form-label">Location</label>
          <input type="text" formControlName="location" class="form-input" placeholder="Optional" />
        </div>
      </div>
    </div>

    <div class="form-section">
      <h2 class="section-title">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
          <circle cx="12" cy="16" r="1" fill="currentColor"/>
          <path d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11" stroke="currentColor" stroke-width="2"/>
        </svg>
        Account Information
      </h2>
      
      <div class="form-grid">
        <div class="form-group">
          <label class="form-label">Username <span class="required">*</span></label>
          <input type="text" formControlName="username" class="form-input" [class.error]="profileForm.get('username')?.invalid && profileForm.get('username')?.touched" />
          <div class="error-message" *ngIf="profileForm.get('username')?.invalid && profileForm.get('username')?.touched">
            Username is required
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Your Referral Code</label>
          <input type="text" formControlName="referralCode" class="form-input readonly" readonly />
        </div>

        <div class="form-group">
          <label class="form-label">Parent Referral Code</label>
          <input type="text" formControlName="parentReferralCode" class="form-input readonly" readonly />
        </div>

        <div class="form-group">
          <label class="form-label">Spouse Referral Code</label>
          <input type="text" formControlName="spouseReferralCode" class="form-input readonly" readonly />
        </div>
      </div>
    </div>

    <div class="form-section">
      <h2 class="section-title">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="2"/>
          <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <path d="M12 16H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        Security
      </h2>
      
      <div class="form-grid">
        <div class="form-group">
          <label class="form-label">Change Password</label>
          <input type="password" formControlName="password" class="form-input" placeholder="Leave blank to keep current password" />
          <small class="help-text">Enter a new password only if you want to change it</small>
        </div>

        <div class="form-group">
          <label class="form-label checkbox-label">
            <input type="checkbox" formControlName="isDeceased" />
            <span>Mark as deceased</span>
      </label>
        </div>
      </div>
    </div>

    <div class="form-actions">
      <button type="submit" class="submit-btn" [disabled]="saving || profileForm.invalid">
        <span *ngIf="saving" class="spinner"></span>
        <span>{{ saving ? 'Saving...' : 'Save Changes' }}</span>
      </button>
    </div>
  </form>
</div>
